import React from 'react';
import './Heading.css';


const Heading=()=>{
    return(
        <div className='Header'>
            <p className='Heading-Information'>Country</p>
            <p className='Heading-Information'>Cases</p>
            <p className='Heading-Information'>Deadth</p>
            <p className='Heading-Information'>Recovery</p>
        </div>
    )
}
export default Heading;
